import { render, staticRenderFns } from "./ChipList.vue?vue&type=template&id=0b5c487e"
import script from "./ChipList.vue?vue&type=script&lang=ts"
export * from "./ChipList.vue?vue&type=script&lang=ts"
import style0 from "./ChipList.vue?vue&type=style&index=0&id=0b5c487e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports